;

(function (GC) {
  window.GC = GC;
  var debug = GC.debug === 'true' || GC.debug === 'analytics';

  var GCAnalytics = function GCAnalytics() {
    var logged = [];
    var queue = [];

    var registerEvent = function registerEvent(event) {
      tracker.events = Object.assign({}, tracker.events, event); // Check to see if any events were fired before the current batch was added

      if (queue.length > 0) {
        queue = queue.map(function (event) {
          // Try to fire the event again
          fireEvent(event.name, event.cb);
        }).filter(function (event) {
          // Filter out any succesful events, since the map function doesn't return
          // anything, this will remove the empty indeces in the queue array.
          return event;
        });
      }
    };

    var fireEvent = function fireEvent(name, cb) {
      cb = cb || function () {};

      var method = tracker.events[name];

      if (method) {
        if (debug) {
          logged.push({
            name: name,
            cb: cb
          });
          GC.log('--ANALYTICS--', 'groupCollapsed');
          GC.log('Fired event name: ' + name, 'info');
        }

        method(cb);

        if (debug) {
          GC.log('--ANALYTICS--', 'groupEnd');
        }
      } else {
        queue.push({
          name: name,
          cb: cb
        });
      }
    };

    var tracker = {
      registerEvent: registerEvent,
      fire: fireEvent,
      events: {}
    };

    if (debug) {
      tracker.logged = logged;
    }

    return {
      tracker: tracker
    };
  };

  GC.queue = GC.queue || [];
  GC.queue.push({
    method: function method(mount, GCmodule) {
      this._loadModule(mount, GCmodule);
    },
    args: ['analytics', new GCAnalytics()]
  });
})(window.GC || {});